import React, {ReactElement, ReactNode} from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import useStyles from "./styles";

export type ModalSectionHeaderProps = {
  title: string;
  actionPanel?: ReactNode;
};

const ModalSectionHeader: React.FC<ModalSectionHeaderProps> = ({
  title,
  actionPanel,
}): ReactElement => {
  const classes = useStyles();

  return (
    <Box className={classes.sectionHeader}>
      <Typography variant="h3" className={classes.sectionHeaderTitle}>
        {title}
      </Typography>
      {actionPanel}
    </Box>
  );
};

export default ModalSectionHeader;
